import React, { Component } from 'react';
import P from 'prop-types';

const LoadingSmall = () => <div>Loading...</div>;

const MAX_RETRIES = 5;

// NOTE: Taken straight from WEB repo
const displayLoading = (config) => {
  const {
    queryName = 'data',
    loadingComponent: LoadingComponent = LoadingSmall,
    // https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-query-data-networkStatus
    minNetworkStatus = 7, // 7 means "ready", and is the default used within apollo
  } = config || {};

  return (ChildComponent) => {
    return class extends Component {
      static displayName =
        `LoadingWrapper(${ChildComponent.displayName || ChildComponent.name})`

      static propTypes = {
        [queryName]: P.shape({
          loading: P.bool,
        }),
      }

      componentDidUpdate(prevProps) {
        const query = this.props[queryName];
        if (!query) return;
        const didUpdateQuery = query !== prevProps[queryName];
        const didLoadWithoutStore = !query.loading && !query.error && !query.store;
        if (didUpdateQuery && didLoadWithoutStore && this._retries < MAX_RETRIES) {
          console.error('forced refetch for query after store came back null', query);
          query.refetch();
          this._retries += 1;
        }
      }

      _retries = 0; // not in state because retries doesn't affect the result of render

      render() {
        const query = this.props[queryName];
        if (query && (query.networkStatus < minNetworkStatus || (!query.store && !query.error))) {
          return <LoadingComponent {...this.props} />;
        }
        return <ChildComponent {...this.props} />;
      }
    };
  };
};

export default displayLoading;
